import { analytics } from '../firebase';
import { logEvent } from 'firebase/analytics';
import styled from 'styled-components';

const StyledAnchor = styled.a`
  color: inherit;
  text-decoration: none;
  &:hover,
  &:active,
  &:focus,
  &:visited {
    color: inherit;
    text-decoration: none;
  }
`;

interface AnchorProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  eventName?: string; // optional custom event name
}

export const Anchor: React.FC<AnchorProps> = ({ eventName, onClick, ...props }) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (eventName) {
      logEvent(analytics, 'link_clicked', {
        url: props.href,
      });
    }
    if (onClick) onClick(e);
  };

  return <StyledAnchor {...props} onClick={handleClick} />;
};
